import type { IconComponent } from '@consta/icons/Icon'
import { Button } from '@consta/uikit/Button'
import { withTooltip } from '@consta/uikit/withTooltip'

import { getSimpleTooltipContent } from '../../../utils'
import { useActionContext } from '../context'

const ButtonWithTooltip = withTooltip({
  mode: 'mouseover',
  appearTimeout: 500,
  exitTimeout: 0,
  direction: 'downCenter',
})(Button)

type ActionButtonProps<T> = {
  tooltipTitle: string
  actionTag: string
  icon: IconComponent
  onApply?: (objects: T[]) => void
}

export const ActionButton = <T,>({
  tooltipTitle,
  actionTag,
  icon,
  onApply,
}: ActionButtonProps<T>) => {
  const { chooseAction, objects } = useActionContext<T>()

  const handleClick = () => {
    if (onApply) {
      onApply(objects)
    } else {
      chooseAction(actionTag)
    }
  }

  return (
    <ButtonWithTooltip
      tooltipProps={{ content: getSimpleTooltipContent(tooltipTitle) }}
      size="xs"
      iconSize="s"
      iconLeft={icon}
      onlyIcon={true}
      view="clear"
      onClick={handleClick}
    />
  )
}
